import { Component, EventEmitter, Input, Output, output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'page-title',
  imports: [],
  templateUrl: './page-title.component.html',
  styleUrl: './page-title.component.scss',
})
export class PageTitleComponent {
  // deps
  @Input() bi_icon: string | undefined;
  @Input() text: string = 'Page Title';
  @Input() enable_nav: boolean = false;
  @Input() nav_mode: 'history' | 'relative' = 'relative';

  // output
  @Output() interrupt = new EventEmitter<() => void>();

  constructor(private router: Router, private currentRoute: ActivatedRoute) {}

  back() {
    if (this.interrupt.observers.length > 0) {
      this.interrupt.emit(() => {
        if (this.nav_mode == 'history') {
          window.history.back();
          return;
        }

        if (this.nav_mode == 'relative') {
          this.router.navigate(['../'], { relativeTo: this.currentRoute });
          return;
        }
      });
      return;
    }

    if (this.nav_mode == 'history') {
      window.history.back();
      return;
    }

    if (this.nav_mode == 'relative') {
      this.router.navigate(['../'], { relativeTo: this.currentRoute });
      return;
    }
  }
}
